import { Action, ActionType, PageLoadedData } from "app/pages/DiscountsList/actionTypes";
import { DiscountListItemDto } from "app/shared/model/DiscountListItemDto";
import { DiscountsListState, DiscountListItem } from "app/pages/DiscountsList/modules/DiscountItemsList/state";


const startingState : DiscountsListState = {
    allDiscounts: [],
    discountsToDisplay: [],
    searchTerm: '',
    statusFilter: 'active',
    typeFilter: [],
    schoolFilter: [],
    sortOrder: 'Alphabetical',
    allSchools: []
}

export function reducer(state: DiscountsListState|undefined, action: Action) : DiscountsListState {
    if (!state) {
        return startingState;
    }

    switch(action.type) {

        case ActionType.ChangeSearchTerm:
            if (state.searchTerm == action.searchTerm)
                return state;

            sessionStorage.setItem('DiscountSearchTerm', action.searchTerm)
            return {
                ...state,
                discountsToDisplay: filterDiscounts(action.searchTerm, state.allDiscounts),
                searchTerm: action.searchTerm
            };

        case ActionType.PageLoaded: {
            const discounts = action.discounts.map(x => createDiscountListItem(x, action.data));
            const searchTerm = sessionStorage.getItem('DiscountSearchTerm') || '';
            const allSchools = [...action.data.schools].sort((a, b) => a.name.localeCompare(b.name));

            return {
                ...state,
                allDiscounts: discounts,
                discountsToDisplay: filterDiscounts(searchTerm, discounts),
                searchTerm,
                allSchools
            };
        }

        case ActionType.ChangeStatusFilter:
            return { ...state, statusFilter: action.statusFilter };

        case ActionType.ChangeTypeFilter:
            return { ...state, typeFilter: action.types };

        case ActionType.ChangeSchoolFilter:
            return { ...state, schoolFilter: action.schoolIds };

        case ActionType.ChangeSortOrder:
            return { ...state, sortOrder: action.sortOrder };

        case ActionType.ResetFilters:
            return { ...state, statusFilter: 'active', typeFilter: [], schoolFilter: [], sortOrder: 'Alphabetical' };

        default:
            return state;
    }
}

function normalizeSchoolId(value: string) {
    const trimmed = String(value ?? '').trim();
    const digits = trimmed.replace(/\D/g, '');
    return digits !== '' ? String(parseInt(digits, 10)) : trimmed.toUpperCase();
}

function createDiscountListItem(dto: DiscountListItemDto, data: PageLoadedData) : DiscountListItem {
    const selectedSchoolIds = new Set((dto.schoolIds ?? []).map(normalizeSchoolId));
    const schools = data.schools.filter(x => selectedSchoolIds.has(normalizeSchoolId(x.code)));
    const countries = data.countries.filter(x => dto.countryCodes.some(y => y == x.id)); 
    const agents = data.agents.filter(x => dto.agentIds.some(y => y == x.id)); 
    
    const currencies = [...new Set((dto.currencies ?? []).filter(Boolean))];

    return {
        id: dto.id, 
        publicName: dto.publicName,
        internalName: dto.internalName,
        discountType: dto.discountType, 
        discountStatus: {
            status: dto.discountStatus.status, 
            description: dto.discountStatus.description, 
        },
        schools: schools, 
        countries: countries,
        agents: agents,
        currencies,
        stringsToSearch: [
            toSearchString(dto.internalName),
            toSearchString(dto.publicName),
            ... schools.map(x => toSearchString(x.name)),
            ... countries.map(x => toSearchString(x.name)),
            ... agents.map(x => toSearchString(x.name))
        ],
        entityUpdate: dto.entityUpdate
    }
}

function toSearchString(str: string) {
    return str.trim().toUpperCase();
}

function filterDiscounts(searchTerm: string, list: DiscountListItem[]) : DiscountListItem[] {
    searchTerm = toSearchString(searchTerm);
    if (searchTerm === '')
        return list;
    return list.filter(item => {
        return item.stringsToSearch.some(x => 
            x.includes(searchTerm)
        );
    })
}